import About from 'routes/About'

export default About
